document.documentElement.classList.add('js');

document.addEventListener('DOMContentLoaded', () => {
  const menuButton = document.querySelector('[data-menu-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');

  if (menuButton && mobileMenu) {
    menuButton.addEventListener('click', () => {
      const isOpen = menuButton.getAttribute('aria-expanded') === 'true';
      menuButton.setAttribute('aria-expanded', String(!isOpen));
      mobileMenu.hidden = isOpen;
      document.body.classList.toggle('menu-open', !isOpen);
    });
  }

  document.querySelectorAll('[data-variant-select]').forEach((select) => {
    select.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      const priceTarget = document.querySelector('[data-product-price]');
      const addButton = document.querySelector('[data-add-to-cart]');
      if (priceTarget && option.dataset.price) priceTarget.textContent = option.dataset.price;
      if (addButton) {
        const available = option.dataset.available === 'true';
        addButton.disabled = !available;
        addButton.dataset.addPrice = option.dataset.price || '';
        addButton.textContent = available ? `ADD TO CART — ${option.dataset.price || ''}` : 'SOLD OUT';
      }
    });
  });

  const quantityInput = document.querySelector('[data-quantity-input]');
  const quantityMinus = document.querySelector('[data-quantity-minus]');
  const quantityPlus = document.querySelector('[data-quantity-plus]');

  if (quantityInput && quantityMinus && quantityPlus) {
    quantityMinus.addEventListener('click', () => {
      quantityInput.value = String(Math.max(1, Number(quantityInput.value || 1) - 1));
      quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
    });

    quantityPlus.addEventListener('click', () => {
      quantityInput.value = String(Math.max(1, Number(quantityInput.value || 1) + 1));
      quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  const stickyAddButton = document.querySelector('[data-sticky-add]');
  const productAddButton = document.querySelector('[data-add-to-cart]');

  if (stickyAddButton && productAddButton) {
    stickyAddButton.addEventListener('click', () => {
      if (!productAddButton.disabled) productAddButton.click();
    });
  }
});
